import { client } from '@/client';

export function getProxyDetectedResult() {
  return client.get('/api/console/getProxyDetectedResult');
}
